import React from 'react';

// Styles & Assets
import styles from './PatientTableCell.module.css';

// Components
import Tooltip from '../../UI/Tooltip/Tooltip';
import NoteCell from '../../UI/NoteCell/NoteCell';


interface Props {
    customStyles: React.CSSProperties,
    value: number | string | null
    comment: string | null | undefined
    onClick?: () => void
}
const PatientTableCell: React.FC<Props> = ({ customStyles, value, comment, onClick }) => {

    return (
        <>
            <td
                onDoubleClick={onClick}
                className={styles.cellTable}
                style={{
                    cursor: onClick ? 'pointer' : 'default',
                    ...customStyles
                }}
            >
                {typeof value !== 'number' ? value : Math.round(value * 100) / 100}
                {comment &&
                    <NoteCell>
                        <Tooltip text={comment || ''}>
                            <div className='note'></div>
                        </Tooltip>
                    </NoteCell>
                }
            </td>
        </>
    );
};

export default PatientTableCell;